import type { ExtractPropTypes, PropType, StyleValue } from 'vue'
import type _Page from './page.vue'

export const sdPageProps = {
    lockScroll : { type: Boolean, default: false                  }, // 锁定滚动
    title      : { type: String                                   }, // 页面标题
    showHead   : { type: Boolean                                  }, // 显示头部 tab 区域
    headClass  : { type: String                                   }, // 头部类名
    headStyle  : { type: [String, Object] as PropType<StyleValue> }, // 头部样式
    bodyClass  : { type: String                                   }, // 内容类名
    bodyStyle  : { type: [String, Object] as PropType<StyleValue> }, // 内容样式
} as const

export type SdPageProps    = ExtractPropTypes<typeof sdPageProps>
export type SdPageInstance = InstanceType<typeof _Page>


